import { useContext } from 'react';

import { SearchContext } from './search-context';

export const useOpenSearchDialog = () => {
  const { openDialog } = useContext(SearchContext);

  return openDialog;
};
